import { render, staticRenderFns } from "./MenuCardUser.vue?vue&type=template&id=dd111afa&scoped=true"
import script from "./MenuCardUser.vue?vue&type=script&lang=js"
export * from "./MenuCardUser.vue?vue&type=script&lang=js"
import style0 from "./MenuCardUser.vue?vue&type=style&index=0&id=dd111afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd111afa",
  null
  
)

export default component.exports